import * as entityTypes from "../../types/admin/dimensionsEntityTypes";

const initialState = {
  loading: false,
  info: null,
  error: null,
};

export const createDimensionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.CREATE_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.CREATE_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.CREATE_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getAllDimensionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ALL_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ALL_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ALL_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getSingleDimensionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ONE_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ONE_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ONE_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateDimensionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.UPDATE_ONE_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.UPDATE_ONE_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.UPDATE_ONE_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const setStatusActionOfDimensionReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.SET_STATUS_ACTIVE_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.SET_STATUS_ACTIVE_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.SET_STATUS_ACTIVE_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const setDimensionsPathHierarchyReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_DIMENSION_PATH_HEIRARCHY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_DIMENSION_PATH_HEIRARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_DIMENSION_PATH_HEIRARCHY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateDimensionsPathHierarchyReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.UPDATE_DIMENSION_PATH_HEIRARCHY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.UPDATE_DIMENSION_PATH_HEIRARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.UPDATE_DIMENSION_PATH_HEIRARCHY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const assignMultipleUsersToDimensionReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.ASSIGN_MULTIPLE_USERS_TO_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.ASSIGN_MULTIPLE_USERS_TO_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.ASSIGN_MULTIPLE_USERS_TO_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getAllUsersToDimensionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_ALL_USERS_TO_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_ALL_USERS_TO_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_ALL_USERS_TO_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const removeUserFromDimensionReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.REMOVE_USER_FROM_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.REMOVE_USER_FROM_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.REMOVE_USER_FROM_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getOverallDimensionHierarchyReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_OVERALL_DIMENSION_HIERARCHY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_OVERALL_DIMENSION_HIERARCHY_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_OVERALL_DIMENSION_HIERARCHY_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getHierarchyByTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_HIERARCHY_BY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_HIERARCHY_BY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_HIERARCHY_BY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateEntityStatusReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.UPDATE_ENTITY_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.UPDATE_ENTITY_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.UPDATE_ENTITY_STATUS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getFormBuilderReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_FORM_BUILDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_FORM_BUILDER_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_FORM_BUILDER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const createFormBuilderReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.CREATE_FORM_BUILDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.CREATE_FORM_BUILDER_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.CREATE_FORM_BUILDER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getClientFormBuilderReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_CLIENT_FORM_BUILDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_CLIENT_FORM_BUILDER_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_CLIENT_FORM_BUILDER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const uploadDocumentCustomerDynamicFormReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.UPLOAD_DOCUMENT_CUSTOMER_DYNAMIC_FORM_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const updateClientFormBuilderReducer = (
  state = initialState,
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.UPDATE_CLIENT_FORM_BUILDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.UPDATE_CLIENT_FORM_BUILDER_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.UPDATE_CLIENT_FORM_BUILDER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getCustomerIdReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_CUSTOMER_ID_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_CUSTOMER_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: null,
      };
    case entityTypes.GET_CUSTOMER_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};

export const getDimensionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case entityTypes.GET_DIMENSION_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case entityTypes.GET_DIMENSION_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload, // this is the dimensions grouped object
        error: null,
      };
    case entityTypes.GET_DIMENSION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: null,
      };
    default:
      return state;
  }
};
